import { useEffect, useState } from 'react';
import useLocalization from './useLocalization';
import toBaseLocale from '../utils/toBaseLocale';

var usePageTranslations = function usePageTranslations() {
  var _process$env$NEXT_PUB;

  var _useLocalization = useLocalization(),
      currentLocale = _useLocalization.currentLocale,
      localeLabels = _useLocalization.localeLabels,
      _useLocalization$tran = _useLocalization.translations,
      translations = _useLocalization$tran === void 0 ? [] : _useLocalization$tran,
      onChangeLocale = _useLocalization.onChangeLocale;

  var _useState = useState(),
      data = _useState[0],
      setData = _useState[1];

  var basePath = (_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_BASE_PATH) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : '';
  useEffect(function () {
    if (currentLocale) {
      var switcherData = {
        currentLocale: {
          locale: toBaseLocale(currentLocale),
          localeLabel: localeLabels[currentLocale]
        },
        translations: translations.map(function (t) {
          return {
            locale: toBaseLocale(t.locale),
            localeLabel: localeLabels[t.locale],
            url: t.url ? "".concat(basePath).concat(t.url) : undefined
          };
        })
      };
      setData(switcherData);
    }
  }, [currentLocale, translations]);
  return [data, {
    onChangeLocale: onChangeLocale
  }];
};

export default usePageTranslations;